/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_FiberInputs */

const en_nutrient_fiber = /** @type {(inputs: Nutrient_FiberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fibre`)
};

const de_nutrient_fiber = /** @type {(inputs: Nutrient_FiberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ballaststoffe`)
};

/**
* | output |
* | --- |
* | "Fibre" |
*
* @param {Nutrient_FiberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_fiber = /** @type {((inputs?: Nutrient_FiberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_FiberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_fiber(inputs)
	return en_nutrient_fiber(inputs)
});